import * as React from 'react';

import {List} from '@common/typescript/objects/List';

import Musthead from '@app/components/UI/MustHead/Musthead';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import {LinkBlockItemActive} from '@app/objects/LinkBlockItem';
import {
	aftercareEmbedText,
	aftercareMustheadText,
	aftercareRichText1,
	aftercareRichText2
} from '@app/components/Pages/Services/Aftercare/aftercareContent';
import RichText from '@app/components/UI/RichText/RichText';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import {Questions} from '@app/objects/Questions';
import {rest} from '@app/components/Api';
import FaqBlockHeaderSm from '@app/components/UI/FaqBlock/FaqBlockHeaderSm';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

const Aftercare = () => {
	const [questions, setQuestions] = React.useState<Questions[]>([]);

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/aftercarePage').then(res => setQuestions(res.list));
	}, []);

	const linkItems: LinkBlockItemActive[] = [
		{
			path: '/our-services/veterinary-hospice',
			name: 'Veterinary Hospice',
		},
		{
			path: '/our-services/in-home-euthanasia',
			name: 'In-Home Euthanasia',
		},
		{
			path: '/our-services/aftercare',
			name: 'Aftercare',
			active: true,
		},
		{
			path: '/our-services/telehospice',
			name: 'Telehospice',
		},
		{
			path: '/our-services/pet-loss-support',
			name: 'Pet Loss Support',
		},
	];

	return (
		<div className="aftercare our-services">
			<Musthead
				title="Cremation & Aftercare"
				imageSrc={require('@app/content/aftercare.png')}
				text={aftercareMustheadText}
				quoteAuthor="Samantha, Dog Mom"
				imageAlt="Pet aftercare options"
			/>
			<VideoEmbed text={aftercareEmbedText} />
			<RichText
				title="Cremation and aftercare options include:"
				text={aftercareRichText1}
			/>
			<RichText
				title="What to expect from cremation"
				text={aftercareRichText2}
			/>
			<div className="care-coordinator__faq">
				<div className="care-coordinator__faq-content">
					<FaqBlockHeaderSm
						title="You might find yourself asking..."
						btnText="View all FAQ"
						clickUrl="/faq"
					/>
					<FaqBlock questions={questions} />
				</div>
			</div>
			<LinkBlockSmall items={linkItems} />
		</div>
	);
};

export default withSeo(Aftercare, state => state.aftercarePage, 'aftercarePage', 'our-services/aftercare');